/* eslint no-underscore-dangle: ["error", { "allow": ["_onChange"] }] */
import React from 'react';
import PermissionsStore from '../../stores/PermissionsStore';
import PermissionsReminderNew from './PermissionsReminderNew';
import PermissionsInstructionsBox from './PermissionsInstructionsBox';
import { browserName } from '../../utils/helpers';

class PermissionsInfoContainer extends React.Component {
  state = {
    permissions: PermissionsStore.getAll(),
    shownInstructions: PermissionsStore.getShownInstructions(),
    animate: [],
  };

  componentDidMount() {
    PermissionsStore.addChangeListener(this._onChange);
  }

  componentWillUnmount() {
    PermissionsStore.removeChangeListener(this._onChange);
  }

  finishReminderAnimation = (type) => {
    const animate = this.state.animate.slice();
    const index = animate.indexOf(type);
    animate.splice(index, 1);
    PermissionsStore.showInstructions(type);
  };

  _onChange = () => {
    const currentPermissions = this.state.permissions;
    const newPermissions = PermissionsStore.getAll();
    const animate = [];

    for (const key in currentPermissions) { // eslint-disable-line no-restricted-syntax
      if (Object.prototype.hasOwnProperty.call(currentPermissions, key)) {
        if (currentPermissions[key] === 0 && newPermissions[key] === 2) {
          animate.push(key);
        }
      }
    }
    this.setState({
      permissions: PermissionsStore.getAll(),
      shownInstructions: PermissionsStore.getShownInstructions(),
      animate,
    });
  };

  render() {
    const { permissions, animate, shownInstructions } = this.state;

    const permissionsReminders = [];
    for (const key in permissions) { // eslint-disable-line no-restricted-syntax
      if (Object.prototype.hasOwnProperty.call(permissions, key)) {
        if ((permissions[key] === 2 || permissions[key] === '2')
          && (key === 'geolocation' && (window.location.pathname.indexOf('search') !== -1))
        ) {
          permissionsReminders.push( // eslint-disable-line function-paren-newline
            <PermissionsReminderNew
              key={key}
              type={key}
              finishAnimation={this.finishReminderAnimation}
              animate={animate.indexOf(key) !== -1}
            />,
          ); // eslint-disable-line function-paren-newline
        }
      }
    }

    const permissionsInstructions = [];
    shownInstructions.forEach((key) => {
      permissionsInstructions.push( // eslint-disable-line function-paren-newline
        <PermissionsInstructionsBox
          type={key}
          browser={browserName()}
          key={key}
        />,
      ); // eslint-disable-line function-paren-newline
    });

    return (
      <div className="permissionsInfoContainer">
        {permissionsInstructions}
        <br />
        {permissionsReminders}
      </div>
    );
  }
}

export default PermissionsInfoContainer;
